import { render, staticRenderFns } from "./BonusesView.vue?vue&type=template&id=7518b8f6"
import script from "./BonusesView.vue?vue&type=script&lang=ts"
export * from "./BonusesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports